import {
  cssTransition,
  Slide,
  toast,
  ToastContent,
  ToastOptions,
} from 'react-toastify';

export const ReactToast = toast;

const None = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  collapseDuration: 10,
});

export type ToastPopoutPosition =
  | 'bottom-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'top-right'
  | 'top-left'
  | 'top-center';

export interface ToastPopoutProps {
  /** Toast content */
  content: ToastContent;
  /** Toast position */
  position?: ToastPopoutPosition;
  /** containerId */
  containerId?: string | number;
  /** toastId */
  toastId?: string | number;
  animate?: boolean;
  autoClose?: number | false;
  closeOnClick?: boolean;
  additionalToastOps?: ToastOptions;
}

const ToastPopout = (props: ToastPopoutProps): void => {
  const {
    content,
    position = 'bottom-right',
    animate = true,
    additionalToastOps,
  } = props;

  ReactToast(content, {
    ...props,
    position,
    transition: animate ? Slide : None,
    ...additionalToastOps,
  });
};

export default ToastPopout;
